module.exports = __webpack_public_path__ + "static/3_2-b0dfc9530474b0a0578286b5ecddfe0c.jpeg";